export default __webpack_public_path__ + "static/media/ods9.18cbe426.svg";